import request from "@/service";
import { _dealResult } from "@/utils/common";

const blobOpts = {
  responseType: "blob",
  headers: {
    Accept: "application/json, text/plain, */*, application/octet-stream",
    "Content-Type": "application/json;charset=UTF-8",
  },
};

export function getClassReportPowerAttachmente(params) {
  return request({
    url: `/study/classReport/powerAttachment`,
    method: "get",
    params,
  });
}

export function getClassReportPowerPage(params) {
  return request({
    url: `/study/classReport/powerPage`,
    method: "get",
    params,
  });
}

/*  */
export function getClassReportReportInfo(params) {
  return request({
    url: `/study/classReport/detail`,
    method: "get",
    params,
  });
}

// ! <--- 班级办班计划表接口
const crp = "/study/classReportPlan";
// * 班级办班计划批量审核
export function auditBatch(data) {
  return request({
    url: `${crp}/auditBatch`,
    method: "post",
    data,
  });
}
// *删除
export function crpFileLibraryDelete(data) {
  return request({
    url: `${crp}/fileLibrary/delete`,
    method: "post",
    data,
  });
}
// * 下载
export function crpDownload(data) {
  return request({
    url: `${crp}/fileLibrary/download`,
    method: "post",
    data,
    ...blobOpts,
  });
}
// * 批量下载附件
export function downloadBatch(data) {
  return request({
    url: `${crp}/downloadBatch`,
    method: "post",
    data,
    ...blobOpts,
  });
}

// * 导出班级办班计划审核列表
export function exportAuditList(data) {
  return request({
    url: `${crp}/exportAuditList`,
    method: "post",
    data,
    ...blobOpts,
  });
}
// * 班级办班计划审核列表
export function pageAudit(params) {
  return request({
    url: `${crp}/pageAudit`,
    method: "get",
    params,
  });
}
// * 办班申报管理资料列表
export function crpFilePage(params) {
  return request({
    url: `${crp}/fileLibrary/page`,
    method: "get",
    params,
  });
}
// * 分页列表
export function classReportPlanPage(params) {
  return request({
    url: `${crp}/page`,
    method: "get",
    params,
  });
}
// * 新增
export function classReportPlanSave(data) {
  return request({
    url: `${crp}/save`,
    method: "post",
    data,
  });
}
// * 修改
export function classReportPlanUpdate(data) {
  return request({
    url: `${crp}/update`,
    method: "post",
    data,
  });
}
// * 删除
export function classReportPlanDelete(data) {
  return request({
    url: `${crp}/delete`,
    method: "post",
    data,
  });
}
// * 详情
export function classReportPlanInfo(params) {
  return request({
    url: `${crp}/info`,
    method: "get",
    params,
  });
}
// * 送审/批量送审
export function reportPlanAudit(data) {
  return request({
    url: `${crp}/planAudit`,
    method: "post",
    data,
  });
}
// * 取消送审
export function cancelPlanAudit(data) {
  return request({
    url: `${crp}/cancelPlanAudit`,
    method: "post",
    data,
  });
}
// * 审核详情
export function auditInfo(params) {
  return request({
    url: `${crp}/auditInfo`,
    method: "get",
    params,
  });
}
// ! --->

// ! <--- 班级文件表接口
const cf = "/study/class/fileLibrary";
// * 分页列表 --- 联络员
export function pageSetClassMaterial(params) {
  return request({
    url: `${cf}/page`,
    method: "get",
    params,
  });
}
// * classReport上传 --- 联络员
export function classReportSave(data) {
  return request({
    url: `${cf}/save`,
    method: "post",
    data,
  });
}
// * classReport下载 --- 联络员
export function classReportDownload(data) {
  return request({
    url: `${cf}/download`,
    method: "post",
    data,
  });
}
// * classReport删除 --- 联络员
export function classReportDelete(data) {
  return request({
    url: `${cf}/delete`,
    method: "post",
    data,
  });
}
// ! --->

// ! <--- 报名、学员管理、班委管理接口
const ce = "/study/class/enroll";
// * 更新报名备注
export function updateRemarks(data) {
  return request({
    url: `${ce}/updateRemarks`,
    method: "post",
    data,
  });
}
// ! --->

// ! <--- 审核申请表接口
const cae = "/study/audit/enroll";
export function exportAudit(data) {
  return request({
    url: `${cae}/exportAudit`,
    method: "post",
    data,
    ...blobOpts,
  });
}
// ! --->

// 中组部选调班分页列表-shijunjian
export function classTransferringPage(data) {
  return request({
    url: `/study/classTransferring/info/page`,
    method: "post",
    data,
  });
}

export function classTransferringInfoNew(params) {
  return request({
    url: `/study/classTransferring/info/infoNew`,
    method: "get",
    params,
  });
}

export function classTransferringDel(data) {
  return request({
    url: `/study/classTransferring/info/delete`,
    method: "post",
    data,
  });
}

export function classTransferringSave(data) {
  return request({
    url: `/study/classTransferring/info/save`,
    method: "post",
    data,
  });
}

export function classTransferringUpdate(data) {
  return request({
    url: `/study/classTransferring/info/update`,
    method: "post",
    data,
  });
}

export function classTransferringPublish(data) {
  return request({
    url: `/study/classTransferring/info/publish`,
    method: "post",
    data,
  });
}

//
export function classTransferringUpdateRemarks(data) {
  return request({
    url: `/study/classTransferring/info/updateRemarks`,
    method: "post",
    data,
  });
}

// 选调班导入培训班级-wangchao
export function importTransferClass(params) {
  return request({
    url: "/study/classTransferring/info/importTransferClass",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut",
    },
    data: params,
  });
}

// 工作人员分页列表
export function $LiaisonPage(data) {
  return request({
    url: `/study/class/liaison/user/page`,
    method: "post",
    data,
  });
}

// 更新工作人员-clc
export function $LiaisonUserUpdate(data, cb) {
  request({
    url: `/study/class/liaison/user/update`,
    method: "post",
    data,
  }).then((res) => _dealResult(res, cb));
}

// 批量删除工作人员-clc
export function $LiaisonUserDelete(data, cb) {
  request({
    url: `/study/class/liaison/user/deleteBatch`,
    method: "post",
    data,
  }).then((res) => _dealResult(res, cb));
}

// 工作人员拖拽排序-clc
export function $LiaisonUserDrag(data, cb) {
  request({
    url: `/study/class/liaison/user/orderByDrag`,
    method: "post",
    data,
  }).then((res) => _dealResult(res, cb));
}
/* 专题讲座管理-分页 */
export function getTopicLectureInfoPage(params) {
  return request({
    url: `/study/topicLectureInfo/page`,
    method: "get",
    params,
  });
}
/* 专题讲座管理-删除 */
export function deleteTopicLectureInfo(data) {
  return request({
    url: `/study/topicLectureInfo/delete`,
    method: "post",
    data,
  });
}
/* 专题讲座管理-发布 */
export function publishTopicLectureInfo(id) {
  return request({
    url: `/study/topicLectureInfo/publish/${id}`,
    method: "get"
  });
}

/* 专题讲座管理-新增 */
export function saveTopicLectureInfo(data) {
  return request({
    url: `/study/topicLectureInfo/save`,
    method: "post",
    data,
  });
}

/* 专题讲座管理-详情 */
export function getTopicLectureInfo(id) {
  return request({
    url: `/study/topicLectureInfo/info/${id}`,
    method: "get"
  });
}

/* 专题讲座管理-新增 */
export function updateTopicLectureInfo(data) {
  return request({
    url: `/study/topicLectureInfo/update`,
    method: "post",
    data,
  });
}

/* 专题讲座管理-学员分页 */
export function getTopicLectureInfoUserPage(params) {
  return request({
    url: `/study/topicLectureInfo/user/page`,
    method: "get",
    params,
  });
}

/* 专题讲座管理-学员新增 */
export function topicLectureInfoUserSave(data) {
  return request({
    url: `/study/topicLectureInfo/user/save`,
    method: "post",
    data,
  });
}

/* 专题讲座管理-学员管理-删除 */
export function topicLectureUserDelete(data) {
  return request({
    url: `/study/topicLectureInfo/user/delete`,
    method: "post",
    data,
  });
}

/* 专题讲座管理-已选学员 */
export function getTopicLectureInfoUserId(params) {
  return request({
    url: `/study/topicLectureInfo/user/id`,
    method: "get",
    params
  });
}
/* 专题讲座管理-学员导出 */
export function topicLectureInfoUserExport(data) {
  return request({
    url: `/study/topicLectureInfo/user/export`,
    method: 'post',
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  })
}

/**
 * 查询理论中心组学习审核详情-clc
 * @param {*} params 
 * @returns 
 */
export function queryLearnDeclare(params) {
  return request({
    url: `/study/topicLecture/queryLearnDeclare`,
    method: "get",
    params
  });
}
/**
 * 查询理论中心组学习审核人员分页-clc
 * @param {*} params 
 * @returns 
 */
export function queryLearnDeclareUser(params) {
  return request({
    url: `/study/topicLecture/queryLearnDeclareUser`,
    method: "get",
    params
  });
}


// 查询理论中心记录分页
export function getTheoreticalRecordList(params) {
  return request({
    url: `/study/topicLecture/learnPage`,
    method: "post",
    data: params
  });
}

// 理论中心记录导入
export function importTheoreticalRecord(params) {
  return request({
    url: "/study/topicLecture/importLearnRecord",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}
// 删除理论中心记录
export function deleteTheoreticalRecord(params) {
  return request({
    url: `/study/topicLecture/deleteLearnRecord`,
    method: "post",
    data: params
  });
}

/* 理论中心组学习申报分页列表-clc */
export function getLearnDeclarePage(data) {
  return request({
    url: `/study/topicLecture/learnDeclarePage`,
    method: "post",
    data,
  });
}
/* 理论中心组学习新增申报-clc */
export function addLearnDeclare(data) {
  return request({
    url: `/study/topicLecture/addLearnDeclare`,
    method: "post",
    data,
  });
}

/* 理论中心组学习批量审核-clc */
export function learnBatchAudit(data) {
  return request({
    url: `/study/topicLecture/learnBatchAudit`,
    method: "post",
    data,
  });
}

/* 其他集中培训记录分页-clc */
export function getOtherTrainRecordPage(data) {
  return request({
    url: '/study/topicLecture/otherTrainPage',
    method: 'post',
    data
  })
}

/* 其他集中培训记录分页-用户学习信息页-clc */
export function getLearnInfoOtherTrainPage(data) {
  return request({
    url: '/study/topicLecture/learnInfoOtherTrainPage',
    method: 'post',
    data
  })
}

// 其他集中培训导入-clc
export function importOtherTrain(params) {
  return request({
    url: "/study/topicLecture/importOtherTrain",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

/* 其他集中培训记录-删除-clc */
export function deleteOtherTrainRecord(data) {
  return request({
    url: `/study/topicLecture/deleteOtherTrain`,
    method: "post",
    data,
  });
}

// 专题讲座导入申报-clc
export function importDeclare(params) {
  return request({
    url: "/study/topicLecture/importDeclare",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

// 理论中心组-导入申报-hj
export function importLearnDeclare(params) {
  return request({
    url: "/study/topicLecture/importLearnDeclare",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

// 其他集中培训-导入申报-hj
export function importOtherDeclare(params) {
  return request({
    url: "/study/topicLecture/importOtherDeclare",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

/* 理论中心组学习申报分页列表-clc */
export function getLearnAuditPage(data) {
  return request({
    url: `/study/topicLecture/learnAuditPage`,
    method: "post",
    data,
  });
}

// 导入工作人员
export function importLiaison(params) {
  return request({
    url: "/study/class/liaison/user/importLiaison",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}

// 
export function queryExamSelectPage(params) {
  return request({
    url: `/study/exam/info/selectPage`,
    method: "get",
    params
  });
}

export function getAuditInfoByAuditUUiids(data) {
  return request({
    url: `/study/audit/enroll/auditInfoClassBatch`,
    method: "post",
    data
  });
}
